export default __webpack_public_path__ + "static/media/2019-12_Sean-Marjason-personal-website-raw-html.ca320668.jpg";